import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import HeaderFour from "../common/header/HeaderFour";
import FooterOne from "../common/footer/FooterOne";
import SEO from "../common/SEO";


const RecruitersLogin = () => {
    const form = useRef();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [result, showResult] = useState(false);


    setTimeout(() => {
        showResult(false);
    }, 5000);

    return (
        <>
            <SEO />
            <main className="main-wrapper">
                <HeaderFour />
                <div
                    className="section section-padding"
                    style={{
                        position: "relative",
                    }}
                >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-5 col-lg-6">
                                <div className="contact-form-box shadow-box ">
                                    <h3 className="title text-center">Recruiters Login</h3>
                                    {/* <div className="form-group">{result ? <Result /> : null}</div> */}
                                    {error && <Alert variant="danger">{error}</Alert>}
                                    <form
                                        ref={form}
                                        className="axil-contact-form"
                                    >
                                        <div className="form-group">
                                            <label>Email address*</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="name@gmail.com"
                                                name="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Password*</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                placeholder="******"
                                                name="password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group gap-2 flex-row">
                                            <button
                                                type="submit"
                                                className="axil-btn try-free-btn btn-fluid btn-primary"
                                                name="submit-btn"
                                            >
                                                Log In
                                            </button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="shape-group-8 list-unstyled">
                        <li className="shape shape-1">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"}
                                alt="Bubble"
                            />
                        </li>
                        <li className="shape shape-2">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"}
                                alt="Bubble"
                            />
                        </li>
                        <li className="shape shape-3">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                                alt="Line"
                            />
                        </li>
                    </ul>
                </div>
                <FooterOne />
            </main>
        </>
    );
};

export default RecruitersLogin;
